import { atom } from 'jotai';

import { formatFullName } from '../../common/utils/userUtils';

export const userFirstNameAtom = atom<string | null>(null);
export const userLastNameAtom = atom<string | null>(null);

// Derived atom for the user's full name formatted
export const userFullNameAtom = atom((get) => {
    return formatFullName(
        get(userFirstNameAtom) ?? '',
        get(userLastNameAtom) ?? '',
    );
});

// Important - Sensitive member data!
// This atom should never be stored locally -- only used in app memory
// The atom was created to prevent the SSN form question from being
// repeated in separate money map flow steps.
export const userSsnFromKycAtom = atom<string | null>(null);
